export default {"src":"/_next/static/media/20lbs.5f4141b0.svg","height":132,"width":180,"blurWidth":0,"blurHeight":0};